var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFingerprint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 131,
    height: 131,
    viewBox: "0 0 131 131",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fingerprint",
    transform: "translate(0 -0.324)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7051",
    "data-name": "Rectangle 7051",
    width: 131,
    height: 131,
    transform: "translate(0 0.324)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64993",
    "data-name": "Path 64993",
    d: "M50.7,132.869a65.391,65.391,0,0,0,6.827-29.205A32.952,32.952,0,0,1,69.845,78",
    transform: "translate(-24.677 -38.038)",
    fill: "none",
    stroke: "#417ee4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64994",
    "data-name": "Path 64994",
    d: "M116.319,128A98.138,98.138,0,0,1,104,175.734",
    transform: "translate(-50.62 -62.375)",
    fill: "none",
    stroke: "#417ee4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64995",
    "data-name": "Path 64995",
    d: "M96,112.425a16.425,16.425,0,1,1,32.849,0,114.1,114.1,0,0,1-10.933,48.966",
    transform: "translate(-46.726 -46.799)",
    fill: "none",
    stroke: "#417ee4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64996",
    "data-name": "Path 64996",
    d: "M125.1,110.017a151.212,151.212,0,0,0,2.772-28.743,49.274,49.274,0,0,0-98.548,0A48.453,48.453,0,0,1,26.5,97.7",
    transform: "translate(-12.898 -15.649)",
    fill: "none",
    stroke: "#417ee4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64997",
    "data-name": "Path 64997",
    d: "M83.99,160a83.1,83.1,0,0,1-9.29,24.586",
    transform: "translate(-36.359 -77.95)",
    fill: "none",
    stroke: "#417ee4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64998",
    "data-name": "Path 64998",
    d: "M120,64.257A35.978,35.978,0,0,1,124.106,64a32.849,32.849,0,0,1,32.849,32.849,133.754,133.754,0,0,1-1.027,16.425",
    transform: "translate(-58.407 -31.224)",
    fill: "none",
    stroke: "#417ee4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64999",
    "data-name": "Path 64999",
    d: "M181.418,192c-.77,3.028-1.642,6.057-2.618,8.982",
    transform: "translate(-87.027 -93.525)",
    fill: "none",
    stroke: "#417ee4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFingerprint);
export default __webpack_public_path__ + "static/media/fingerprint.69a06bf0d7dd6399c28f3ef8daecc3c2.svg";
export { ForwardRef as ReactComponent };